import { isPlatform } from '@ionic/vue';
import { setConferenceView, extractConfTypeFromPath } from './conference-type';

export const createRedirectUri = (packageId, domain) => {
  const isNative = isPlatform('ios') || isPlatform('android');
  const isNativeBrowser = isPlatform('mobileweb');

  return isNative && !isNativeBrowser
    ? `${packageId}://${domain}/capacitor/${packageId}/callback`
    : window.location.origin + '/callback';
};

export const createLogoutUri = (packageId, domain) => {
  const isNative = isPlatform('ios') || isPlatform('android');
  const isNativeBrowser = isPlatform('mobileweb');

  return isNative && !isNativeBrowser
    ? `${packageId}://${domain}/capacitor/${packageId}/logout`
    : window.location.origin;
};

export const redirectNoAccess = router => {
  router.push('/');
};

export const redirectDeepLinkPath = async (router, url, store = null) => {
  console.log('url:', url);
  const urlObj = new URL(url);
  console.log('urlObj.origin', urlObj.origin);
  if (urlObj.origin === process.env.VUE_APP_APP_DOMAIN) {
    const params = new URLSearchParams(urlObj.search);
    const paramsObject = {};
    for (const [key, value] of params.entries()) {
      paramsObject[key] = value;
    }
    // this one for redirect after deep linking login
    const deepLinkPathObj = {
      path: urlObj.pathname,
      query: paramsObject,
      hash: urlObj.hash,
    };
    console.log('deepLinkPathObj', deepLinkPathObj);

    // Set conference mode from deep link URL before routing.
    // Only when URL has an explicit prefix (/gpcr/*, /gic/*).
    // For unprefixed/shared paths, don't touch mode —
    // getCurrentConferenceType() handles it already.
    const confType = extractConfTypeFromPath(urlObj.pathname);
    if (confType) {
      setConferenceView(confType);
      // See redirectShortLinkPath in deeplink.js for why this matters: the
      // router's mode-drives-route guard resolves off a memoized profile
      // fetch, so without a fresh fetch here a stale cache can bounce this
      // link back to the old default conference instead of the new one.
      if (store?.state?.profile?.name) {
        await store.dispatch('profile/forceFetchProfile');
      }
    }

    sessionStorage.setItem('deepLinkPathObj', JSON.stringify(deepLinkPathObj));
    router.push(deepLinkPathObj);
    return true;
  }
  console.log('redirectDeepLinkPath: false');
  return false;
};

export const storeLoginPath = url => {
  console.log('store login:', url);
  const urlObj = new URL(url);
  const params = new URLSearchParams(urlObj.search);
  const paramsObject = {};
  for (const [key, value] of params.entries()) {
    paramsObject[key] = value;
  }
  const loginPathObj = {
    path: urlObj.pathname,
    query: paramsObject,
    hash: urlObj.hash,
  };

  // Set conference mode from URL before login redirect.
  // Same logic as redirectDeepLinkPath — only for explicit prefixes (/gpcr/*, /gic/*).
  const confType = extractConfTypeFromPath(urlObj.pathname);
  if (confType) {
    setConferenceView(confType);
  }

  sessionStorage.setItem('loginPathObj', JSON.stringify(loginPathObj));
};

export const getLoginPathObj = () => {
  const str = sessionStorage.getItem('loginPathObj');
  if (!str) return null;
  return JSON.parse(str);
};

export const clearLoginPathObj = () => {
  sessionStorage.removeItem('loginPathObj');
};
